/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from "react";
import AccountDetailEdit from "./AccountDetailEdit";
import ChangePasswordModule from "./ChangePasswordModule";
import { getAccountData } from "../../services/AuthServices";
import _ from "lodash";
import Loader from "../../containers/Loader";
import DrawDetails from "./DrawDetails";
import OrderDetails from "./OrderDetails";
import { useLocation, useNavigate } from "react-router-dom";
import "./AccountDetail.css";

function AccountDetailLayout() {
  const [data, setdata] = useState({});
  const [isLoading, setisLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedTab, setselectedTab] = useState(location?.state?.draw ? 1 : 0);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setisLoading(true);
    await getAccountData()
      .then((response) => {
        setisLoading(false);
        setdata(response?.data?.data);
      })
      .catch((error) => {
        setisLoading(false);
      });
  };

  const tabItems = [
    {
      name: "My Profile",
      icon: "far fa-user",
    },
    {
      name: "My Draws",
      icon: "far fa-gift",
    },
    {
      name: "My Orders",
      icon: "far fa-shopping-bag",
    },
    {
      name: "Security",
      icon: "far fa-lock",
    },
  ];

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login");
  };

  const getUserName = () => {
    const firstName = data?.first_name || "";
    const lastName = data?.last_name || "";
    return `${firstName} ${lastName}`.trim() || "User";
  };

  const getUserEmail = () => {
    return data?.email || "user@example.com";
  };

  return (
    <div className="dp-account-page">
      <div className="dp-account-container">
        <div className="dp-account-layout">
          {/* Sidebar */}
          <div className="dp-account-sidebar">
            {/* Sidebar Header with Avatar */}
            <div className="dp-sidebar-header">
              <div className="dp-sidebar-avatar">
                <i className="far fa-user"></i>
              </div>
              <h3 className="dp-sidebar-name">{getUserName()}</h3>
              <p className="dp-sidebar-email">{getUserEmail()}</p>
            </div>

            {/* Sidebar Navigation */}
            <nav className="dp-sidebar-nav">
              {tabItems.map((tab, index) => (
                <button
                  key={index}
                  className={`dp-sidebar-nav-item ${selectedTab === index ? "active" : ""}`}
                  onClick={() => setselectedTab(index)}
                >
                  <i className={tab.icon}></i>
                  <span>{tab.name}</span>
                </button>
              ))}
            </nav>

            <div className="dp-sidebar-divider"></div>

            {/* Logout Button */}
            <button className="dp-sidebar-logout" onClick={handleLogout}>
              <i className="far fa-sign-out-alt"></i>
              <span>Logout</span>
            </button>
          </div>

          {/* Main Content Area */}
          <div className="dp-account-content">
            {/* Greeting Header */}
            <div className="dp-account-greeting">
              <h1>
                Hello, {data?.first_name || "User"} <span role="img" aria-label="wave">👋</span>
              </h1>
              <p>Manage your account settings and preferences</p>
            </div>

            {/* Content Tabs (visible on larger screens as secondary nav) */}
            <div className="dp-content-tabs">
              {tabItems.map((tab, index) => (
                <button
                  key={index}
                  className={`dp-content-tab ${selectedTab === index ? "active" : ""}`}
                  onClick={() => setselectedTab(index)}
                >
                  <i className={tab.icon}></i>
                  {tab.name}
                </button>
              ))}
            </div>

            {/* Tab Content */}
            {isLoading ? (
              <div className="dp-account-loading">
                <Loader />
              </div>
            ) : (
              <>
                {selectedTab === 0 && !_.isEmpty(data) && (
                  <AccountDetailEdit data={data} />
                )}
                {selectedTab === 1 && (
                  <DrawDetails
                    setselectedTab={setselectedTab}
                    data={data?.lottery}
                  />
                )}
                {selectedTab === 2 && (
                  <OrderDetails
                    setselectedTab={setselectedTab}
                    data={data?.order}
                  />
                )}
                {selectedTab === 3 && (
                  <ChangePasswordModule setselectedTab={setselectedTab} />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccountDetailLayout;
